import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { content, BannerHomeMobile, BannerHomeMobile2 } from "../assets/images";
import ArrowLine from "../assets/images/ArrowLine";

const Home = () => {
    const [subIndex, setSubIndex] = useState(0);
    const contents = [
        <div className="space-y-4" key={0}>
            <p className="text-[48px] font-saira font-semibold text-white">Uncover Rare</p>
            <p className="text-[48px] font-saira font-semibold text-white">Techniques</p>
        </div>,
        <div className="space-y-4" key={1}>
            <p className="text-[48px] font-saira font-semibold text-white">Guided by</p>
            <p className="text-[48px] font-saira font-semibold text-white">Masters</p>
        </div>
    ];
    const handlePrev = () => {
        if (subIndex > 0) setSubIndex(subIndex - 1);
    };

    const handleNext = () => {
        if (subIndex < contents.length - 1) setSubIndex(subIndex + 1);
    };
    return (
        <>
            <div className="w-full h-full overflow-hidden mx-auto bg-bannerHomePage bg-cover bg-no-repeat bg-center grid-cols-12 lg:grid hidden">
                <div className="col-span-3 col-start-9 h-full space-y-[90px] flex flex-col items-center justify-center">
                    <img src={content} />
                    <div className="bg-[#00000026] p-4 rounded-2xl text-[48px] font-thin font-sf text-white max-w-[350px] backdrop-blur-[27.6px]">
                        Your personal oasis for a mindful life
                    </div>
                </div>
            </div>
            <div className="bg-[#000000] bg-opacity-80 w-full h-full">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={subIndex} // thay đổi khi subIndex đổi để kích hoạt animation
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.6, ease: "easeInOut" }}
                        className={` max-lg:flex hidden w-full h-full ${subIndex === 0 ? "bg-BannerHomeMobile" : "bg-BannerHomeMobile2"} bg-cover bg-no-repeat bg-center items-center`}
                    >
                        <div className="w-full flex items-center justify-center">
                            <div className="space-y-8 px-4">
                                {
                                    subIndex === 0 ?
                                        <>
                                            <img src={content} className="mx-auto max-h-[177px]" />
                                            <div className="flex gap-x-2 items-center justify-center">
                                                <div className="bg-[#FFFFFF26] rounded-3xl text-[24px] font-thin font-sf text-white backdrop-blur-[27.6px] w-[99px] h-[45px] flex items-center justify-center">
                                                    Swipe
                                                </div>
                                                <ArrowLine />
                                            </div>
                                        </>
                                        :
                                        <div className="h-[300px]">
                                        </div>

                                }
                                <div className="gap-x-8 flex items-center justify-center">
                                    {contents.map((val, index) => {
                                        return (
                                            <div
                                                key={index}
                                                onClick={() => { setSubIndex(index) }}
                                                className={`w-6 h-6 rounded-full cursor-pointer ${index === subIndex
                                                    ? "bg-white"
                                                    : "bg-[#FFFFFF26] backdrop-blur-[27.6px]"
                                                    }`}
                                            />
                                        )
                                    })}
                                </div>
                                <div className="bg-[#FFFFFF26] p-4 rounded-2xl text-[24px] font-thin font-sf text-white w-full backdrop-blur-[27.6px]">
                                    Your personal oasis for a mindful life
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </AnimatePresence>
            </div>
        </>

    );
}
export default Home;